"use client";

import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription, DialogFooter } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";

export default function AssetViewDialog({
  open,
  onOpenChange,
  selectedAsset,
  getQuantitySnapshot,
  onEdit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-lg max-h-[85vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Asset details</DialogTitle>
          <DialogDescription>Summary and maintenance history (read-only)</DialogDescription>
        </DialogHeader>
        {selectedAsset ? (
          <div className="space-y-4 text-sm">
            {(() => {
              const q = getQuantitySnapshot(selectedAsset);
              return (
                <>
                  <div className="grid grid-cols-2 gap-x-4 gap-y-2">
                    <span className="text-muted-foreground">ID</span><span>{selectedAsset.asset_id}</span>
                    <span className="text-muted-foreground">Name</span><span className="font-medium">{selectedAsset.asset_name}</span>
                    <span className="text-muted-foreground">Category</span><span>{selectedAsset.category}</span>
                    <span className="text-muted-foreground">Model / Serial</span><span>{selectedAsset.model_number || "-"} / {selectedAsset.serial_number || "-"}</span>
                    <span className="text-muted-foreground">Vendor</span><span>{selectedAsset.vendor_name || "-"}</span>
                    <span className="text-muted-foreground">Assigned to</span><span>{selectedAsset.assigned_to || "-"}</span>
                    <span className="text-muted-foreground">Location</span><span>{selectedAsset.location || "-"}</span>
                    <span className="text-muted-foreground">Condition</span><span>{selectedAsset.condition}</span>
                    <span className="text-muted-foreground">Status</span><span>{selectedAsset.status}</span>
                    <span className="text-muted-foreground">Purchase</span>
                    <span>{selectedAsset.purchase_date ? new Date(selectedAsset.purchase_date).toLocaleDateString() : "-"} · Rs{Number(selectedAsset.purchase_cost || 0).toLocaleString()}</span>
                    <span className="text-muted-foreground">Current value</span><span>Rs{Number(selectedAsset.current_value || 0).toLocaleString()}</span>
                  </div>
                  <div className="rounded-lg border p-3 bg-muted/20">
                    <p className="font-medium mb-2">Units</p>
                    <p>Total <strong>{q.total}</strong> - In use <strong>{q.inSvc}</strong>, needs repair <strong>{q.repair}</strong>{q.spare > 0 ? <> , available/storage <strong>{q.spare}</strong></> : null}</p>
                  </div>
                </>
              );
            })()}
            <div>
              <p className="font-medium mb-2">Maintenance history</p>
              {selectedAsset.maintenance_history?.length ? (
                <ul className="space-y-2 border rounded-md divide-y max-h-48 overflow-y-auto">
                  {selectedAsset.maintenance_history.map((m, idx) => (
                    <li key={idx} className="p-2 text-xs">
                      <div className="font-medium">{m.date ? new Date(m.date).toLocaleDateString() : "-"} · {m.type || "-"}</div>
                      {m.description && <p className="text-muted-foreground mt-1">{m.description}</p>}
                      <div className="text-muted-foreground mt-1">{m.cost != null && m.cost > 0 && <>Rs{Number(m.cost).toLocaleString()} · </>}{m.technician || ""}</div>
                    </li>
                  ))}
                </ul>
              ) : (
                <p className="text-muted-foreground text-xs">No maintenance records yet.</p>
              )}
            </div>
          </div>
        ) : null}
        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>Close</Button>
          <Button className="bg-[#0263cc] hover:bg-[#0263cc]/90" onClick={onEdit}>Edit</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
